const dialog = document.querySelector('.header__dialog');
const trigger = document.querySelector('.header__nav__trigger');
const close = document.querySelector('.header__dialog__close');

const onClose = (e) => {
    dialog.classList.remove('header__dialog--open');
};

trigger.addEventListener('click', (e) => {
    dialog.classList.add('header__dialog--open');
});

close.addEventListener('click', onClose);

// Optional: close when clicking outside the dialog inner
dialog.addEventListener('click', (e) => {
    if (e.target === dialog) onClose();
});
